



































import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from 'vuex-class';
import t from '@/i18n/translations';

const formNamespace = 'form';
const progressNamespace = 'progress';

@Component({

})
export default class ReportStart extends Vue {
    @Action('fetchBranches', { namespace: formNamespace }) fetchBranches: any;
    @Action('show', { namespace: progressNamespace }) show: any;
    
    @Getter('getBranches', { namespace: formNamespace }) getBranches: any;
    
    @Mutation('toggleProgress', { namespace: progressNamespace }) toggleProgress: any;
    @Mutation('clearAnswers', { namespace: formNamespace }) clearAnswers: any;
    @Mutation('clearForm', { namespace: formNamespace }) clearForm: any;
    
    @Mutation('setStep1Unactive', { namespace: progressNamespace }) setStep1Unactive: any;
    @Mutation('setStep2Unactive', { namespace: progressNamespace }) setStep2Unactive: any;
    @Mutation('setStep3Unactive', { namespace: progressNamespace }) setStep3Unactive: any;

    selectedBranchID: string = '';
    i18n = t['nl'];

    mounted(): void {
        this.toggleProgress('start');
        this.show();

        this.clearAnswers();
        this.clearForm();

        this.setStep1Unactive();
        this.setStep2Unactive();
        this.setStep3Unactive();
    }

    onBranchClicked(selectedBranch:string) {
        this.selectedBranchID = selectedBranch;
        this.$router.push({ name: 'report/introduction' })
    }

    onSelectClicked() { }
}
